import { useEffect } from "react";

declare global {
  interface Window {
    FreshworksWidget: any;
    fwSettings: any;
  }
}

const FreshdeskWidget = () => {
  const WIDGET_ID = import.meta.env.VITE_APP_FRESHDESK_WIDGET_ID;
  useEffect(() => {
    // Add the Freshdesk widget configuration
    window.fwSettings = {
      widget_id: WIDGET_ID, // Replace with your actual widget ID
    };

    // Dynamically add the Freshdesk widget script
    const script = document.createElement("script");
    script.src = `https://ind-widget.freshworks.com/widgets/${WIDGET_ID}.js`; // Replace with your widget ID
    script.async = true;
    script.defer = true;

    // Add custom styles for the widget
    const style = document.createElement("style");
    style.innerHTML = `
      #launcher-frame {
        max-width: 90px !important;
      }
    `;

    // Append the script and style to the document
    document.head.appendChild(style);
    document.body.appendChild(script);

    const waitForFreshworksWidget = () => {
      if (typeof window.FreshworksWidget === "function") {
        // Call FreshworksWidget methods after it is fully loaded
        window.FreshworksWidget("identify", "ticketForm", {
          email: "care@sardadairy.in", // Replace with the user's email
        });

        window.FreshworksWidget("disable", "ticketForm", ["email"]);
      } else {
        // Retry after 100ms if FreshworksWidget is not yet available
        setTimeout(waitForFreshworksWidget, 100);
      }
    };

    // Start polling for FreshworksWidget availability
    script.onload = waitForFreshworksWidget;
    // Execute FreshworksWidget methods after the script has loaded
    // script.onload = () => {
    //   // Identify user with ticket form details
    //   setTimeout(() => {
    //     if (window.FreshworksWidget) {
    //       window.FreshworksWidget("identify", "ticketForm", {
    //         email: "care@sardadairy.in", // Replace with the user's email
    //       });

    //       // Disable specific fields in the ticket form
    //       window.FreshworksWidget("disable", "ticketForm", ["email"]);
    //     }
    //   }, 500);
    // };

    // Cleanup: Remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
      document.head.removeChild(style);
    };
  }, []);

  return null; // No UI, just the widget integration
};

export default FreshdeskWidget;
